export default function formatPhoneNumber(number: string): string {
  const koreaRegex = /^010\d{8}$/;
  const taiwanRegex = /^09\d{8}$/;
  const hongKongRegex = /^(?:(?:852|853))?\d{8}$/;
  const chinaRegex = /^(?:86)?1\d{10}$/;

  if (taiwanRegex.test(number)) {
    return `${number.slice(0, 4)}-xxx-xx${number.slice(9, 10)}`;
  } else if (koreaRegex.test(number)) {
    return `${number.slice(0, 3)}-${number.slice(3, 4)}xxx-${number.slice(7, 8)}xxx`;
  } else if (hongKongRegex.test(number)) {
    let num = number;

    if (num.startsWith("852") || num.startsWith("853")) num = num.slice(3);

    return `${num.slice(0, 4)}-${num.slice(4)}`;
  } else if (chinaRegex.test(number)) {
    let num = number;

    if (num.startsWith("86")) num = num.slice(2);

    return `${num.slice(0, 3)}-${num.slice(3, 7)}-${num.slice(7)}`;
  } else {
    return "Invalid number";
  }
}
